/* auth */
export const currentUser = ({auth}) => auth.user
export const currentStore = ({auth}) => auth.user && auth.user.store
export const currentEnterprise = ({auth}) => auth.user && auth.user.enterprise
export const isSystemAdmin = ({auth}) => auth.user && auth.user.role_name === 'SYSTEM_ADMIN'
export const isStoreAdmin = ({auth}) => auth.user && auth.user.role_name === 'STORE_ADMIN'

/* messages */
export const messageStack = ({ messages }) => messages.stack
export const getWebsock = ({ messages }) => messages.websock
// 获取语音消息以及下载状态的
export const messagesData = ({ messages }) => messages.messages_data
// 获取下载中心文件下载状态
export const downloadData = ({ messages }) => messages.download_data

/* notifications */
export const notificationStack = ({notifications}) => notifications.stack
export const playlist = ({notifications}) => notifications.playlist

/* profiles */
export const staff = ({profiles}) => profiles.staff
export const stores = ({profiles}) => profiles.stores
export const insurances = ({profiles}) => profiles.insurances
export const brands = ({profiles}) => profiles.brands
export const salesAssistants = ({profiles}) => profiles.salesAssistants
export const mechanics = ({profiles}) => profiles.mechanics
export const shopCategories = ({profiles}) => profiles.shopCategories



// WEBPACK FOOTER //
// ./src/vuex/getters.js